"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var codegen_1 = require("ajv/dist/compile/codegen");

var _util_1 = require("./_util");

var error = {
  message: function message(_ref) {
    var missingPattern = _ref.params.missingPattern;
    return codegen_1.str(_templateObject || (_templateObject = _taggedTemplateLiteral(["should have property matching pattern '", "'"])), missingPattern);
  },
  params: function params(_ref2) {
    var missingPattern = _ref2.params.missingPattern;
    return codegen_1._(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["{missingPattern: ", "}"])), missingPattern);
  }
};

function getDef() {
  return {
    keyword: "patternRequired",
    type: "object",
    schemaType: "array",
    error: error,
    code: function code(cxt) {
      var gen = cxt.gen,
          schema = cxt.schema,
          data = cxt.data;
      if (schema.length === 0) return;
      var valid = gen.let("valid", true);

      var _iterator = _createForOfIteratorHelper(schema),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var pat = _step.value;
          validateProperties(pat);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      function validateProperties(pattern) {
        var matched = gen.let("matched", false);
        gen.forIn("key", data, function (key) {
          gen.assign(matched, codegen_1._(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ".test(", ")"])), _util_1.usePattern(gen, pattern), key));
          gen.if(matched, function () {
            return gen.break();
          });
        });
        cxt.setParams({
          missingPattern: pattern
        });
        gen.assign(valid, codegen_1.and(valid, matched));
        cxt.pass(valid);
      }
    },
    metaSchema: {
      type: "array",
      items: {
        type: "string",
        format: "regex"
      },
      uniqueItems: true
    }
  };
}

exports.default = getDef;
module.exports = getDef;